import { Card } from '@bancobarigui/barihaus';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { TopProvider } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface TopProvidersChartProps {
  data: TopProvider[];
  loading?: boolean;
  onBarClick?: (providerId: string, providerName: string) => void;
  title?: string;
}

export function TopProvidersChart({ data, loading = false, onBarClick, title = 'Top Prestadoras (por volume)' }: TopProvidersChartProps) {
  const chartData = {
    labels: data.map(item => item.name),
    datasets: [
      {
        label: 'Total de Vistorias',
        data: data.map(item => item.total),
        backgroundColor: '#722ed1',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    onClick: (_event: any, elements: any[]) => {
      if (elements.length > 0 && onBarClick) {
        const index = elements[0].index;
        const provider = data[index];
        onBarClick(provider.providerId, provider.name);
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return `Total: ${context.parsed.x} vistorias`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title={title} bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '400px' }}>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
